import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagKY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M24.933 24.999H25v-.067l-.067.067Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 13.043V0h-.004C11.19.002 0 11.194 0 25h13.043v-7.345L20.389 25h4.545l.067-.067V20.39l-7.345-7.345H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M35.87 18.479a4.348 4.348 0 1 0 0-8.696 4.348 4.348 0 0 0 0 8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M12.648 3.262a25.119 25.119 0 0 0-9.387 9.387V25h6.521V9.784H25V3.262H12.648Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m25 21.927-8.883-8.882h-3.074L25 25.001v-3.074ZM28.26 13.045h15.218v6.522H28.261v-6.522Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M28.26 29.347v4.348h2.288a7.578 7.578 0 0 0 5.321 2.173c2.072 0 3.95-.83 5.321-2.173h2.288v-4.348H28.26Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M28.26 18.479V25c0 5.825 7.61 7.61 7.61 7.61s7.608-1.785 7.608-7.61V18.48H28.26Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F3F3F3",
  d: "M35.869 21.963c-1.902 0-1.902 1.739-3.804 1.739s-1.902-1.74-3.804-1.74v3.044c1.902 0 1.902 1.74 3.804 1.74s1.902-1.74 3.804-1.74 1.902 1.74 3.804 1.74c1.903 0 1.903-1.74 3.805-1.74v-3.043c-1.902 0-1.902 1.739-3.805 1.739-1.902 0-1.902-1.74-3.804-1.74ZM35.869 15.87c-1.902 0-1.902 1.739-3.804 1.739s-1.902-1.74-3.804-1.74v3.044c1.902 0 1.902 1.74 3.804 1.74s1.902-1.74 3.804-1.74 1.902 1.74 3.804 1.74c1.903 0 1.903-1.74 3.805-1.74V15.87c-1.902 0-1.902 1.739-3.805 1.739-1.902 0-1.902-1.74-3.804-1.74Z"
}));
FlagKY.displayName = 'FlagKY';
export default withFlagWrapper(FlagKY);
//# sourceMappingURL=index.js.map